export const NPWP_HARDCODED = "31.648.314.8-422.000";
